import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import { Button as PrimeButton } from '../PrimeReactComponents'

import PermDetailsWrapper from '../common/PermDetailsWrapper';
import { checkPermissions } from '../utils';


function Button(props) {
    const [isOnHold, setIsOnHold] = useState(false)
    const [holdCounter, setHoldCounter] = useState(8000)
    const [maxHoldCounter, setMaxHoldCounter] = useState(8000)

    const userDetails = useSelector(state => state.userDetails)

    const permissions = props.permissions ? props.permissions : []
    const permParameters = props.permParameters ? props.permParameters : {}

    const tooltipMsg = props.tooltip ? props.tooltip : ""

    let disabled = false 

    let isPermitted = false
    let permittedCompanyRoleIds = [] 
    let permittedExceptionUserRoleIds = []
    let permittedExceptionNegitiveUserRoleIds = []

    if(permissions.length){
        const permParams = {
            reqPermActionIds: permissions,
            permParameters: permParameters,
            activeCompanyRoleId: userDetails.activeCompanyRoleId,
            userRoleId: userDetails.activeRoleId,
            permExceptions: userDetails.permExceptions,
            permGeo: userDetails.permGeo,
            permActions: userDetails.permActions,
            permRoles: userDetails.permRoles,
            companyRoles: userDetails.companyDetails.companyRoles
        }
        const permissionDetails = checkPermissions(permParams)

        isPermitted = permissionDetails.isPermitted
        permittedCompanyRoleIds = permissionDetails.permittedCompanyRoleIds
        permittedExceptionUserRoleIds = permissionDetails.permittedExceptionUserRoleIds
        permittedExceptionNegitiveUserRoleIds = permissionDetails.permittedExceptionNegitiveUserRoleIds

        if(!permissionDetails.isPermitted){
            disabled = true
        }
    }

    if(props.disabled || isOnHold){
        disabled = true
    }

    useEffect(() => {
        if(props.maxHoldCounter){
            setMaxHoldCounter(props.maxHoldCounter)
            setHoldCounter(props.maxHoldCounter)
        }
    }, [])

    useEffect(() => {
        let intervalId

        if (isOnHold) {
            intervalId = setInterval(() => {
                setHoldCounter(holdCounter => holdCounter - 1000)
            }, 1000)
        }
        if(holdCounter === 0){
            clearInterval(intervalId)
            setHoldCounter(maxHoldCounter)
            setIsOnHold(false)
        } 
        
        if(!isOnHold){
            clearInterval(intervalId)
        }

        return () => clearInterval(intervalId)
    }, [isOnHold, holdCounter])

    const handleExecuteFunc = (e) => {
        props.onClick(e)
    }

    /*const throttledOnClickFunc = _.throttle(props.onClick ? (e) => handleExecuteFunc(e) : () => {}, 8000, { leading: true, trailing: false })

    const throttledFunction = useMemo(() => {
        return throttledOnClickFunc
    }, [])*/

    const throttledOnClickFunc = useMemo(() => _.throttle((e) => {
        if(props.onClick){
            handleExecuteFunc(e)
        }
    }, 8000, { leading: true, trailing: false }), [props.onClick])

    const handleOnClick = (e) => {
        if(props.applyThrottle){
            if(props.onClick){
                //throttledFunction(e)
                throttledOnClickFunc(e)
                setIsOnHold(true)
            }
        } else {
            if(props.onClick){
                props.onClick(e)
            }
        }
    }

    let displayHoldCounter = holdCounter
    if(holdCounter){
        displayHoldCounter = holdCounter / 1000
    }

    const renderButton = () => {
        return (
            <PrimeButton 
                {...props} 
                label={(displayHoldCounter && isOnHold) ? displayHoldCounter : props.label} 
                onClick={handleOnClick} 
                disabled={disabled} 
                tooltip={tooltipMsg}
            />
        )
    }
 
    return (
        <PermDetailsWrapper
            displayComponent={renderButton()}
            uniqueId={props.label}
            permissions={permissions}
            permittedCompanyRoleIds={permittedCompanyRoleIds}
            permittedExceptionUserRoleIds={permittedExceptionUserRoleIds}
            permittedExceptionNegitiveUserRoleIds={permittedExceptionNegitiveUserRoleIds}
            visible={!props.disabled && !isPermitted}
        />
    )
}

export default Button;